<template>
    <section>
        <MainLayout>
            <section>
                <div class="container">
                    <form>
                        <b-form-row>

                        </b-form-row>
                        <b-form-row>
                            <b-form-group class="col-md-2" label="Reporte">
                                <b-form-select size="sm" v-model="moduleSelected" :options="optionsModule"> </b-form-select>
                            </b-form-group>

                            <b-form-group class="col-md-2"  label="Criterio Fechas">
                                <b-form-select size="sm" v-model="filters.dateCriteria" :options="optionsCriteriaDates" > </b-form-select>
                            </b-form-group>

                            <b-form-group class="col-md-2" label="Fecha servicio desde *">
                                <b-form-datepicker locale="es" :class="{'active-filter':filters.startDate}" reset-button size="sm" v-model="filters.startDate"/>
                            </b-form-group>

                            <b-form-group class="col-md-2" label="Hasta *">
                                <b-form-datepicker locale="es" :class="{'active-filter':filters.endDate}" reset-button  size="sm" v-model="filters.endDate"/>
                            </b-form-group>

                            <b-form-group class="col-md-3 table-responsive text-center" label="Comparar por">
                                <b-form-radio-group
                                        id="btn-radios-1"
                                        v-model="filters.groupByCriteria"
                                        :options="optionsRadio"
                                        buttons
                                        name="radios-btn-default"
                                ></b-form-radio-group>
                            </b-form-group>
                            <b-form-group class="col-md-1 table-responsive" label="">
                                <br>
								<b-button variant="warning" v-b-toggle="'advanced-filters'" class="btn mr-2" id="advanced-filters"><md-icon icon="filter_list"/></b-button>
                                <b-tooltip target="advanced-filters" triggers="hover">Mostrar/Ocultar Filtros avanzados</b-tooltip>
                                <b-button variant="outline-primary" type="button" @click="checkform()"><md-icon icon="search"/></b-button>
                            </b-form-group>
                        </b-form-row>

                        <b-collapse id="advanced-filters">
                            <b-form-row>

								<b-form-group class="col-lg-3" label="Estado de servicio">
									<multiselect
										v-model="filters.status"
										:options="statusOpts"
										group-label="group"
										group-values="options"
										group-select
										multiple
										label="text"
										track-by="value"
										placeholder="Todos"
										taggable
									>
										<template v-slot:clear >
											<div class="multiselect__clear" @click="filters.status = []"></div>
										</template>
									</multiselect>
								</b-form-group>
                                <b-form-group class="col-md-3 mt-0" >
                                    <label>Canal de venta <md-icon icon="info" id="tooltip-info" /></label>
                                    <b-tooltip target="tooltip-info" triggers="hover">
                                        Si seleccionan algun canal de venta, solo el resultado de las <b>GRAFICAS</b> será afectado
                                    </b-tooltip>
                                    <GroupedSalesChannelsSelect
                                        v-model="filters.salesChannels"
                                        placeholder="Todos"
                                    />
                                </b-form-group>

								<b-form-group
									class="col-lg-3"
									label="Proveedor"
								>
									<multiselect
										v-model="filters.supplier"
										:options="suppliersOpts"
										group-label="group"
										group-values="options"
										group-select
										multiple
										label="text"
										track-by="value"
										placeholder="Todos"
										taggable
									>
										<template v-slot:clear >
											<div class="multiselect__clear" @click="filters.supplier = []"></div>
										</template>
									</multiselect>
								</b-form-group>
								
                            </b-form-row>
							<b-form-row>
								<b-form-group class="col-md-2" label="Fecha servicio desde *">
									<b-form-datepicker locale="es" :class="{'active-filter':filters.serviceStartDate}" reset-button size="sm" v-model="filters.serviceStartDate"/>
								</b-form-group>

								<b-form-group class="col-md-2" label="Hasta *">
									<b-form-datepicker locale="es" :class="{'active-filter':filters.serviceEndDate}" reset-button  size="sm" v-model="filters.serviceEndDate"/>
								</b-form-group>
								<b-form-group class="col-lg-3" label="Categoria del servicio Venta">
									<multiselect
										v-model="filters.categoryServiceDistribution"
										:options="serviceTypesCategoriesOpts"
										group-label="group"
										group-values="options"
										group-select
										multiple
										label="text"
										track-by="value"
										placeholder="Todos"
										taggable
									>
										<template v-slot:clear >
											<div class="multiselect__clear" @click="filters.serviceTypeCategory = []"></div>
										</template>
									</multiselect>
								</b-form-group>
								<b-form-group class="col-lg-3" label="Categoria del servicio Prov">
									<multiselect
										v-model="filters.categoryServiceSupplier"
										:options="serviceTypesCategoriesOpts"
										group-label="group"
										group-values="options"
										group-select
										multiple
										label="text"
										track-by="value"
										placeholder="Todos"
										taggable
									>
										<template v-slot:clear >
											<div class="multiselect__clear" @click="filters.serviceTypeCategory = []"></div>
										</template>
									</multiselect>
								</b-form-group>
								
							</b-form-row>
							<b-form-row>

								<b-form-group
									v-if="$hasPermission('filters.trip')"
									class="col-lg-1"
									label="Viaje"
								>
									<b-form-select
										:class="{ 'active-filter': filters.trip }"
										v-model="filters.trip"
										:options="tripOpts"
									/>
								</b-form-group>

								<b-form-group class="col-lg-4" label="Zonas Aeropuerto">
									<template slot="label">
										Zona aeropuertos <md-icon icon="info" v-b-tooltip.hover title="Se aplicará el filtro con los aeropuertos que se encuentren dentro de esta zona" />
									</template>
									<multiselect v-model="filters.zonesApto"
										:options="zonedAreasGroupedOpts"
										:multiple="true"
										group-values="zones"
										group-label="zonedArea"
										:group-select="true"
										placeholder="Type to search"
										track-by="text"
										label="text">
											<span slot="noResult">Oops! No se encontraron resultados.</span>
											<template v-slot:clear ><div class="multiselect__clear" @click="filters.zonesApto = []"></div></template>
											<template slot="option" slot-scope="props">
												<div class="option__desc" v-if="props.option.$groupLabel">
													<span class="option__title">{{ props.option.$groupLabel }}</span><br>
												</div>
												<div class="option__desc"  v-else>
													<span class="option__title">{{ props.option.text }}</span><br>
													<small class="option__small text-muted">{{ props.option.zonedAreaName }}</small>
												</div>
											</template>
											<template slot="option-group" slot-scope="props">
												<div class="option__desc">
												<span class="option__title">{{ props.option.text }}</span><br>
												<small class="option__small text-muted">{{ props.option.zonedAreaName }}</small>
												</div>
											</template>
									</multiselect>
								</b-form-group>

								<b-form-group class="col-lg-6" label="Zonas Master">
									<multiselect v-model="filters.zones"
										:options="zonedAreasGroupedOpts"
										:multiple="true"
										group-values="zones"
										group-label="zonedArea"
										:group-select="true"
										placeholder="Type to search"
										track-by="text"
										label="text">
											<span slot="noResult">Oops! No se encontraron resultados.</span>
											<template v-slot:clear ><div class="multiselect__clear" @click="filters.zones = []"></div></template>
											<template slot="option" slot-scope="props">
												<div class="option__desc" v-if="props.option.$groupLabel">
													<span class="option__title">{{ props.option.$groupLabel }}</span><br>
												</div>
												<div class="option__desc"  v-else>
													<span class="option__title">{{ props.option.text }}</span><br>
													<small class="option__small text-muted">{{ props.option.zonedAreaName }}</small>
												</div>
											</template>
											<template slot="option-group" slot-scope="props">
												<div class="option__desc">
												<span class="option__title">{{ props.option.text }}</span><br>
												<small class="option__small text-muted">{{ props.option.zonedAreaName }}</small>
												</div>
											</template>
									</multiselect>
								</b-form-group>
							</b-form-row>
                        </b-collapse>
                    </form>
                </div>
            </section>
			<div v-if="$hasPermission('dashboard.show')">
            <operationDashboard v-if="this.moduleSelected ==='operations'" :filters="filtersClean" :triggerSearch="triggerSearch"></operationDashboard>
            <comercialDashboard v-if="this.moduleSelected ==='comercial'" :filters="filtersClean" :triggerSearch="triggerSearch"></comercialDashboard>
            <AdminDashboard v-if="this.moduleSelected ==='admin'" :filters="filtersClean" :triggerSearch="triggerSearch"></AdminDashboard>
            <DemoDashboard v-if="this.moduleSelected ==='demo'" :filters="filtersClean" :triggerSearch="triggerSearch"></DemoDashboard>
			</div>
        </MainLayout>
    </section>
</template>
<script>

    import MainLayout from '../layout/MainLayout.vue'
    import OperationDashboard from './singles/Operations.vue'
    import ComercialDashboard from './singles/Comercial.vue'
    import AdminDashboard from './singles/Admin.vue'
    import DemoDashboard from './singles/Demo.vue'
    import moment from 'moment'
    import Multiselect from 'vue-multiselect';
    import GroupedSalesChannelsSelect from '../../helpers/GroupedSalesChannelsSelect';
    export default {
        name: "Index",
        components:{MainLayout,OperationDashboard,ComercialDashboard,Multiselect,GroupedSalesChannelsSelect,AdminDashboard,DemoDashboard},
        data(){
            let pickUpStart = moment().subtract(7, 'days').format("YYYY-MM-DD");
            let pickUpEnd = moment().subtract(1, 'days').format("YYYY-MM-DD");

            return {
                triggerSearch:0,
                moduleSelected:"operations",
                loadingToday:false,
                loading:false,
                codeReport : "passengers",
                filters:{
                    dateCriteria:'service-date',
                    startDate:pickUpStart,
                    endDate:pickUpEnd,
                    groupByCriteria:'per-month',
                    salesChannels:[],
					supplier:[],
					zones:[],
					zonesApto:[],
					status:[
						{ value: "noShow",text: "No show",class: "info" },
						{ value: "done",text: "Realizado",class: "info" },
						{ value: "active",text: "Activo",class: "info" }
					],
					trip:0,
					categoryServiceDistribution:[],
					categoryServiceSupplier:[],
					serviceStartDate:null,
					serviceEndDate:null
                },
                selected:'per-day',
                optionsModule:[
                    { text: 'Operaciones', value: 'operations' },
                    { text: 'Comercial', value: 'comercial' },
                    { text: 'Admin', value: 'admin' },
                    { text: 'Demo', value: 'demo' },
                ],
                optionsRadio:[
                    { text: 'Dia', value: 'per-day' },
                    { text: 'Semana', value: 'per-week' },
                    { text: 'Mes', value: 'per-month'},
                    { text: 'Año', value: 'per-year' },
                ],
                optionsCriteriaDates:[
                    { text: 'Por fecha de servicio', value: 'service-date'},
                    { text: 'Por fecha de reserva', value: 'reservation-date' },
					{ text: 'Por fecha de asignación', value: 'assigned-date' },
                ]
            }
        },
        methods:{
            checkform(){
                let errors = [];
                if(this.filters.startDate ==="" || this.filters.endDate === ""){
                    errors.push("Fecha inicio y fecha fin son requeridos");
                }
                if(this.filters.dateCriteria ===""){
                    errors.push("Criterio fechas es requerido");
                }
                if(errors.length===0){
                    this.search();
                }else{
                    this.$root.showAlert(errors[0],{variant:'warning'});
                }
            },
            search(){
                this.triggerSearch++;
            }
        },

        mounted(){
			
            this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['serviceTypesCategories','salesChannelsOpts','masterZonedAreasOpts','suppliersOpts','transportServiceStatusOpts']})
            //this.checkform();//realiza la busqueda
        },
        computed:{
			filtersClean(){
				let zonesIds    = this.filters.zones.map((item)=>item.value);
				let zonesAptoIds    = this.filters.zonesApto.map((item)=>item.value);
				let supplierIds = this.filters.supplier.map((item)=>item.value)
				let statusIds  = this.filters.status.map((item)=>item.value)
				let cpFilters = {...this.filters};
				let sctSupplier  = this.filters.categoryServiceSupplier.map((item)=>item.value)
				let sctDis       = this.filters.categoryServiceDistribution.map((item)=>item.value)
				cpFilters.zones = zonesIds;
				cpFilters.supplier = supplierIds;
				cpFilters.status = statusIds;
				cpFilters.zonesApto = zonesAptoIds;
				cpFilters.categoryServiceSupplier     = sctSupplier;
				cpFilters.categoryServiceDistribution = sctDis;
				return cpFilters;
			},
			zonedAreasGroupedOpts(){
				let grouped = [];
				this.$root.auxVars.masterZonedAreasOpts.forEach((ele)=>{
					let item = {
						zonedArea:ele.name,
						zones:ele.zones.map((aux)=>({value:aux.id,text:aux.name,zonedAreaName:ele.name}))
					};
					grouped.push(item)

				})
					return grouped
			},
			suppliersOpts(){
				return [
					{
						group: "SELECT ALL",
						options: this.$root.auxVars.suppliersOpts
					}
				];
			},
			statusOpts() {
				return [
					{
						group: "SELECT ALL",
						options: this.$root.auxVars.transportServiceStatusOpts
					}
				];
			},
			tripOpts() {
				let aux = [...this.$root.auxVars.tripOpts];
				aux.unshift({ value: 0, text: "Todos" });
				return aux;
			},
			serviceTypesCategoriesOpts() {
				return [
					{
						group: "SELECT ALL",
						options: this.$root.auxVars.serviceTypesCategoriesOpts
					}
				];
		},
		},


    }
</script>
<style scoped>

</style>
